export const ADD_AMOUNT_TO_WALLET_REQUEST = "ADD_AMOUNT_TO_WALLET_REQUEST";

export const ADD_AMOUNT_TO_WALLET_SUCCESS = "ADD_AMOUNT_TO_WALLET_SUCCESS";

export const ADD_AMOUNT_TO_WALLET_FAILURE = "ADD_AMOUNT_TO_WALLET_FAILURE";

export const RESET_WALLET_STORE_SUCCESS = "RESET_WALLET_STORE_SUCCESS";

export const GET_WALLET_DETAILS_FAILURE = "GET_WALLET_DETAILS_FAILURE";

export const UPDATE_WALLET_AFTER_PG_SUCCESS_FAILURE = "UPDATE_WALLET_AFTER_PG_SUCCESS_FAILURE"

export const GET_WALLET_DETAILS_REQUEST = "GET_WALLET_DETAILS_REQUEST";

export const GET_WALLET_DETAILS_SUCCESS = "GET_WALLET_DETAILS_SUCCESS";